import { render, staticRenderFns } from "./ActiveRank.vue?vue&type=template&id=2d1edf5a&scoped=true"
import script from "./ActiveRank.vue?vue&type=script&lang=js"
export * from "./ActiveRank.vue?vue&type=script&lang=js"
import style0 from "./ActiveRank.vue?vue&type=style&index=0&id=2d1edf5a&prod&lang=scss&scoped=true"
import style1 from "./ActiveRank.vue?vue&type=style&index=1&id=2d1edf5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1edf5a",
  null
  
)

export default component.exports